<template>
    <div
            class="form-table__body__td__appended__icon">
        <v-tooltip bottom
                   :disabled="!icon.description || !icon.description(byString(item.raw, header.key), item.raw) || !icon.description(byString(item.raw, header.key), item.raw).trim()">
            <template v-slot:activator="{ on }">
                <v-btn
                        v-if="icon.icon && icon.icon(byString(item.raw, header.key), item.raw)"
                        v-on="on"
                        icon
                        small
                        :color="icon.color && icon.color(byString(item.raw, header.key), item.raw)"
                        style="height: 24px;"
                        @click.stop="icon.callback && icon.callback(byString(item.raw, header.key), item.raw)">
                    <v-icon>{{ icon.icon(byString(item.raw, header.key), item.raw) }}</v-icon>
                </v-btn>
                <template v-else-if="icon.src && icon.src(byString(item.raw, header.key), item.raw)">
                    <v-btn
                            v-on="on"
                            icon
                            small
                            :color="icon.color && icon.color(byString(item.raw, header.key), item.raw)"
                            style="height: 24px;"
                            @click.stop="icon.callback && icon.callback(byString(item.raw, header.key), item.raw)">
                        <img :src="icon.src(byString(item.raw, header.key), item.raw)"
                             style="width: 20px; height: 20px;"/>
                    </v-btn>
                </template>
            </template>
            <span v-if="icon.description">{{ icon.description(byString(item.raw, header.key), item.raw) }}</span>
        </v-tooltip>
    </div>
</template>

<script>
    import tableUtilManager from "@/assets/plugins/mps-form-table/plugins/common/util/table-util-manager";

    export default {
        name: "FormTableTdIcon",
        props: {
            icon: {
                type: Object,
                default: () => {
                },
            },
            item: {
                type: Object,
                default: () => {
                },
            },
            header: {
                type: Object,
                default: () => {
                },
            },
        },
        methods: {
            byString(o, s) {
                return tableUtilManager.byString(o, s);
            },
        },
    }
</script>

<style scoped>
    .form-table__body__td .form-table__body__td__appended__icon {
        margin: 0 3px;
    }

    .form-table__body__td .form-table__body__td__appended__icon:last-child {
    }
</style>